import React, { useState } from 'react';
import { useStateContext } from '../../contexts/ContextProvider';

const OperationReportGenerator = () => {
        const { currentMode } = useStateContext();
        const [formData, setFormData] = useState({
                // Patient Details
                patientName: '',
                dob: '',
                address: '',
                phone: '',
                date: new Date().toISOString().split('T')[0],

                // Medical Team
                proceduralist: '',
                anaesthetist: '',
                assistant: '',
                venue: '',

                // Clinical Details
                diagnosis: '',
                itemNumbers: '',
                procedure: '',
                details: '',
        });

        const handleInputChange = (e) => {
                const { name, value } = e.target;
                setFormData(prevState => ({
                        ...prevState,
                        [name]: value
                }));
        };

        const handleGenerateReport = () => {
                // This will generate the report and open it in the DocumentEditor
                console.log('Generating report with:', formData);
                // TODO: Add logic to generate report and open in DocumentEditor
        };

        return (
                <div className="flex flex-col min-h-screen bg-white dark:bg-gray-900">
                        <div className="bg-white dark:bg-gray-800 p-4 border-b border-gray-200 dark:border-gray-700">
                                <div className="flex justify-between items-center">
                                        <h1 className="text-xl font-semibold text-gray-900 dark:text-white">Operation Report Generator</h1>
                                        <button
                                                onClick={handleGenerateReport}
                                                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
                                        >
                                                Generate Report
                                        </button>
                                </div>
                        </div>

                        <div className="flex-1 p-6 overflow-auto">
                                <form className="space-y-8">
                                        {/* Patient Details Section */}
                                        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow">
                                                <h2 className="text-lg font-medium text-gray-900 dark:text-white mb-4">Patient Details</h2>
                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                                        <div>
                                                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                                                        Patient Name
                                                                </label>
                                                                <input
                                                                        type="text"
                                                                        name="patientName"
                                                                        value={formData.patientName}
                                                                        onChange={handleInputChange}
                                                                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                                                                />
                                                        </div>
                                                        <div>
                                                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                                                        Date of Birth
                                                                </label>
                                                                <input
                                                                        type="date"
                                                                        name="dob"
                                                                        value={formData.dob}
                                                                        onChange={handleInputChange}
                                                                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                                                                />
                                                        </div>
                                                        <div>
                                                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                                                        Address
                                                                </label>
                                                                <input
                                                                        type="text"
                                                                        name="address"
                                                                        value={formData.address}
                                                                        onChange={handleInputChange}
                                                                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                                                                />
                                                        </div>
                                                        <div>
                                                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                                                        Phone
                                                                </label>
                                                                <input
                                                                        type="text"
                                                                        name="phone"
                                                                        value={formData.phone}
                                                                        onChange={handleInputChange}
                                                                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                                                                />
                                                        </div>
                                                </div>
                                        </div>

                                        {/* Medical Team Section */}
                                        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow">
                                                <h2 className="text-lg font-medium text-gray-900 dark:text-white mb-4">Medical Team</h2>
                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                                        <div>
                                                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                                                        Proceduralist
                                                                </label>
                                                                <input
                                                                        type="text"
                                                                        name="proceduralist"
                                                                        value={formData.proceduralist}
                                                                        onChange={handleInputChange}
                                                                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                                                                />
                                                        </div>
                                                        <div>
                                                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                                                        Anaesthetist
                                                                </label>
                                                                <input
                                                                        type="text"
                                                                        name="anaesthetist"
                                                                        value={formData.anaesthetist}
                                                                        onChange={handleInputChange}
                                                                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                                                                />
                                                        </div>
                                                        <div>
                                                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                                                        Assistant
                                                                </label>
                                                                <input
                                                                        type="text"
                                                                        name="assistant"
                                                                        value={formData.assistant}
                                                                        onChange={handleInputChange}
                                                                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                                                                />
                                                        </div>
                                                        <div>
                                                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                                                        Venue
                                                                </label>
                                                                <input
                                                                        type="text"
                                                                        name="venue"
                                                                        value={formData.venue}
                                                                        onChange={handleInputChange}
                                                                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                                                                />
                                                        </div>
                                                </div>
                                        </div>

                                        {/* Clinical Details Section */}
                                        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow">
                                                <h2 className="text-lg font-medium text-gray-900 dark:text-white mb-4">Clinical Details</h2>
                                                <div className="space-y-6">
                                                        <div>
                                                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                                                        Diagnosis
                                                                </label>
                                                                <input
                                                                        type="text"
                                                                        name="diagnosis"
                                                                        value={formData.diagnosis}
                                                                        onChange={handleInputChange}
                                                                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                                                                />
                                                        </div>
                                                        <div>
                                                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                                                        Item Numbers
                                                                </label>
                                                                <input
                                                                        type="text"
                                                                        name="itemNumbers"
                                                                        value={formData.itemNumbers}
                                                                        onChange={handleInputChange}
                                                                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                                                                />
                                                        </div>
                                                        <div>
                                                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                                                        Procedure
                                                                </label>
                                                                <textarea
                                                                        name="procedure"
                                                                        value={formData.procedure}
                                                                        onChange={handleInputChange}
                                                                        rows={3}
                                                                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                                                                />
                                                        </div>
                                                        <div>
                                                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                                                        Details
                                                                </label>
                                                                <textarea
                                                                        name="details"
                                                                        value={formData.details}
                                                                        onChange={handleInputChange}
                                                                        rows={6}
                                                                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                                                                />
                                                        </div>
                                                </div>
                                        </div>
                                </form>
                        </div>
                </div>
        );
};

export default OperationReportGenerator;